import Page_ResponsivePageWithColorBGComponent from '@wix/thunderbolt-elements/src/thunderbolt-core-components/Page/viewer/skinComps/Responsive/ResponsivePageWithColorBG.skin';


const Page_ResponsivePageWithColorBG = {
  component: Page_ResponsivePageWithColorBGComponent
};


export const components = {
  ['Page_ResponsivePageWithColorBG']: Page_ResponsivePageWithColorBG
};

